import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'ng2-charts';
import { EnergyComponent } from './energy.component';
import { EnergyConsumptionComponent } from './energy-consumption/energy-consumption.component';
import { EnergyGenerationComponent } from './energy-generation/energy-generation.component';
import { EnergyPowerComponent } from './energy-power/energy-power.component';
import { EnergyPredictionComponent } from './energy-prediction/energy-prediction.component';
import { EnergyResumeComponent } from './energy-resume/energy-resume.component';
import { ConsumptionResumeComponent } from './energy-resume/consumption-resume/consumption-resume.component';
import { GenerationResumeComponent } from './energy-resume/generation-resume/generation-resume.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { FormsModule } from '@angular/forms';
import { EnergyService } from './energy.service';
import { EnergyTabComponent } from './energy-tab/energy-tab.component';
import { RouterModule } from '@angular/router';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { ConsumptionGasResumeComponent } from './energy-resume/consumption-resume/consumption-gas-resume/consumption-gas-resume.component';
import { EnergyGasComponent } from './energy-gas/energy-gas.component';
import { HomeModule } from '../home/home.module';
import { EnergyReportsComponent } from './energy-reports/energy-reports.component';
import { EnergyReportsService } from './energy-reports/energy-reports.service';

@NgModule({
  imports: [
    CommonModule,
    ChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormsModule,
    RouterModule,
    LoadingModule,
    SharedModule
  ],
  exports: [
    EnergyConsumptionComponent,
    EnergyGenerationComponent
  ]
  ,
  declarations: [
    EnergyComponent,
    EnergyConsumptionComponent,
    EnergyGenerationComponent,
    EnergyPowerComponent,
    EnergyPredictionComponent,
    EnergyResumeComponent,
    ConsumptionResumeComponent,
    GenerationResumeComponent,
    EnergyTabComponent,
    ConsumptionGasResumeComponent,
    EnergyGasComponent,
    EnergyReportsComponent,
  ],
  providers: [
    EnergyService,
    EnergyReportsService]
})
export class EnergyModule { }



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy.module.ts